import digitalWalletStore from "@/stores/digital.wallet.store";
import { formatDate, formatAmount } from "@/util";
import { Grid } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AttentionIcon } from "../../assets/icons/attention-small-icon.svg";

interface IBulkWalletsUpdateStepFour { }

const BulkWalletsUpdateStepFour: FC<IBulkWalletsUpdateStepFour> = () => {
    const { t } = useTranslation();
    const request = digitalWalletStore.bulkUpdateDigitalWalletsRequest;

    return (
        <Grid className="bulk-update-steps-content" sx={{ maxWidth: "330px" }}>
            <Grid className="bulk-update-steps-title">
                {t("digitalWallet.AreYouSureToUpdate")} {request.digitalWallets.length} {t("digitalWallet.Wallets")}?
            </Grid>
            <Grid className="bulk-update-step-four-content">
                <Grid className="bulk-update-step-four-card">
                    <Grid className="bulk-update-card-amount">
                        {request.amount !== null && request.amount !== undefined && request.amount !== 0 && (
                            <>
                                <Grid className="font-style-white-16">{t("digitalWallet.EmployeeBudget")}:</Grid>
                                <Grid className="font-style-white-32-bold ">
                                    {!request.isReset && request.amount > 0 && <span>+</span>}
                                    {request.amount && formatAmount(request.amount, 1)}
                                </Grid>
                            </>
                        )}
                    </Grid>
                    <Grid
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",
                        }}
                    >
                        {request.expiredDate && (
                            <>
                                <Grid className="font-style-white">{t("digitalWallet.NewExpirationDate")}:</Grid>
                                <Grid className="font-style-white-18-bold">
                                    {request.expiredDate && <span>{formatDate(request.expiredDate.toString())}</span>}
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Grid>

                {request.amount !== null && request.amount !== undefined && request.amount !== 0 && (
                    <Grid
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "0.1fr 1fr",
                            gap: "10px",
                            marginTop: "20px",
                        }}
                    >
                        <AttentionIcon />
                        <Grid
                            sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "16px",
                                color: "#586A84",
                            }}
                        >
                            <span>{t("digitalWallet.TotalUploadingAmountOfAll")}</span>{" "}
                            <span>{request.digitalWallets.length}</span> <span>{t("digitalWallet.EmployeesIs")}</span>{" "}
                            {formatAmount(request.amount ? request.digitalWallets.length * request.amount : 0, 1)}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default BulkWalletsUpdateStepFour;
